import React from 'react'
import { Box, Chip } from '@mui/material'
import Liste from './Liste'
import SearchBar from './SearchBar'
import Title from '../../SpiderWebSite/components/Title'
import { useSelector } from 'react-redux'
import { IReduxState } from '../../store'

export default function Services() {

    return (
        <Box sx={{ flexGrow: 1, width: "100%" }}>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                <Title
                    intitule='Liste des établissements ayant activés les web services'
                />
                <Box sx={{ width: "50%"}}>
                    <SearchBar />
                </Box>
            </Box>
            <Liste />
        </Box>
    )
}
